import Component from 'vue-class-component';
import { getQueryString } from '@/utils/location';
// import PageState from "./store/state"
import Vue from 'vue';
import moduleStore from './store/accredit';
import finishImg from '@/assets/images/activity/icon_caozuodianji_finish.svg';
import caozuoImg from '@/assets/images/activity/icon_caozuodianji.svg';
import { Toast } from 'vant'
import PageState from './store/state';
const TIME = 2 * 60 * 1000

import activityMixin from '@/mixins/activity-mixin'

@Component({
  mixins: [activityMixin]
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})

export default class AccreditPage extends Vue  {
  state = new PageState() 
  qrCodeUrl = ''
  isLoadingComplete = false
  wwToken = ''
  currentActivity: any = {}
  userStatus = -1
  isShow = false // 显示弹窗
  type = ''
  time = 0
  statusTimer = null
  showPopup = false
  currPlatformIdx = 0
  platforms = [{key:'dou_yin',value:'抖音'},{key:'kuai_shou',value:'快手'}]
  mounted() {
    this.wwToken = getQueryString('ww_token')||localStorage.getItem('ww_token')
    this.type = getQueryString('type')
    if (this.wwToken && this.wwToken !== 'null') {
     localStorage.setItem('ww_token', this.wwToken)
     this.getActivity()
    } else {
      console.log("tologin");
      const url = location.origin + '/#/accredit'
      this.$navigateTo({
         url: `/pages/login/login?redirect=${encodeURIComponent(`/pages/webview/webview?url=${encodeURIComponent(url)}&navtitle=魔友活动`)}` 
        })
    }
    
  }
  beforeDestoryed() {
    this.clearStatusTimer()
  }
  /**
   * 获取二维码
   */
  getQrCode() {
    console.log('getQrCode 请求');
    let platform = this.platforms[this.currPlatformIdx]['key'];
    this.$http(`getCodeUrl`,{platform}).then(res => {
      if (res.code === 200) {
        this.qrCodeUrl = res.data.qrCode
        this.isLoadingComplete = false
        this.time = TIME;
        this.$refs.countDownRef && (this.$refs.countDownRef as any).reset()
       let timer: any = setTimeout(() => {
          clearTimeout(timer)
          timer = null
          this.isLoadingComplete = true
        }, TIME)
      }
    }).catch((error) => {
      this.isLoadingComplete = true
    })
  }
  refreshQrCode() {
    this.type = 'refresh'
    this.isLoadingComplete = false
    this.getQrCode()
    this.getActivity()
  }
  saveErcode() {
    Toast({
      message: '当前平台不支持下载，请截图保存'
    })
  }
  // 活动描述
  get activeText() {
    if (this.currentActivity.status === 2) {
      return '活动已结束'
    }
    else if (this.currentActivity.status === 1) {
      return '活动进行中'
    }
    return '活动已结束'
  }
  
  /**
   * 获取活动
   */
  getActivity() {
    this.$http('getActivityInfo').then((res: any) => {
      if (res.code === 200) {
        const currentActivity = res.data.currentActivity
        const lastActivity = res.data.lastActivity
        if (currentActivity) {
          this.currentActivity = currentActivity
          if (currentActivity.status === 1) {
            this.setLocalActivity(currentActivity)
            this.getStatus()
          } 
        } else {
          this.currentActivity = lastActivity
        }
        this.setLocalActivity(this.currentActivity)
      } 
      
    })
  }
  /**
   * 获取用户状态
   */
  getStatus() {
    console.log('getStatus 请求');
    this.$http('getUsableStatus', {activityId:this.currentActivity.activityId})
      .then(res => {
        if (res.code === 200) {
          this.userStatus = res.data.status
          this.setLocalActivity({
            ...this.currentActivity, 
            userStatus: this.userStatus
          })
          if (this.userStatus === 1 || this.userStatus === 2) {
            if (this.type !== 'timer') {
              this.getQrCode()
            }
            if (this.type !== 'refresh' && 
            this.type !== 'join' && 
            this.type !== 'timer') {
              this.isShow = true
            }
          } else if (this.userStatus === 3 && (!this.type || this.type === 'timer') ) {
            this.$router.replace({
              name: 'activityPage'
            })
            
          }
          if (this.type === 'join') {
            if (this.userStatus && this.userStatus === 3) {
              this.$router.replace({
                name: 'activityPage'
              })
             
            }
          } else if (this.type === 'add') {
            this.getQrCode()
          }
          if (this.userStatus === 3) {
            this.clearStatusTimer()
            return
          }
          if (!this.statusTimer && this.type !== 'add') {
            clearInterval(this.statusTimer)
            this.statusTimer = setInterval(() => {
              this.type = 'timer'
              this.getStatus()
            }, 3 * 1000)
          }
        }
      })
  }
  clearStatusTimer() {
    this.statusTimer && clearInterval(this.statusTimer)
    this.statusTimer = null
    this.type = ''
  }
  setLocalActivity(currentActivity) {
    localStorage.setItem('currentActivity', JSON.stringify(currentActivity))
  }
  /**
   * 参加活动
   */
  handleJoinActivity() {
    this.$http('joinActivity', {activityId: this.currentActivity.activityId})
      .then(res => {
        if (res.code === 200) {
          this.type = 'join'
          this.getStatus()
        } else {
          Toast({
            message: res.message || '报名出错'
          })
        }
      }).catch((e) => {
        let message = e?.response?.data?.message || e?.message || '报名出错';
        if (message === '已经参加该活动') {
          // 奇怪的代码，已参加，后端返回500 statusCode
          if (this.userStatus === 2) {
            // 已经参加未授权
            message = '报名成功, 请去抖音或快手授权'
          }
        }
        Toast({
          message
        })
      }).finally(()=>{
        this.isShow = false
      })
  }
  /**
   * 查看排行榜
   */
  catActivityRank() {
    this.$router.push({
      name: 'leaderboardPage'
    })
  }

  get iconPath() {
    if (this.currentActivity.status === 2 || this.userStatus === 3) {
      return finishImg
    }
    return caozuoImg
  }
  triggerChange(idx){
    if(idx!=this.currPlatformIdx){
      this.currPlatformIdx = idx;
      this.getQrCode()
      this.showPopup = false;
      
    }
  }
}